import * as z from "zod/v4";

export const getRecentOrders = {
  name: "getRecentOrders" as const,
  input: z.object({ limit: z.number().min(1).max(50).default(10).optional() }),
  output: z.object({
    orders: z.array(z.any()), // We'll return Trackable[] but Zod doesn't need to validate the complex type
  }),
};
